'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _DatePicker = _interopRequireDefault(require("Components/Forms/Elements/V2/DatePicker"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Switch = _interopRequireDefault(require("Components/Forms/Elements/Switch"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _utilities = require("Shared/utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const {
  app
} = window;
class NewsForm extends _react.Component {
  state = {
    status_messages: {},
    'news[images]': [],
    'news[documents]': [],
    'news[visibility]': false
  };
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchNews();
    }
  }
  fetchNews = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/news/get-all', {
      id: props.id || document.location.pathname.split('/contenu/liste-des-actualites/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const images = (response.news[0]?.images || []).map(function (data) {
        const descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1)
        };
        return descriptor;
      });
      delete response.news[0].images;
      const documents = (response.news[0]?.documents || []).map(function (data) {
        const descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data?.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.news[0].documents;
      const update = (0, _getStateFromObject.default)({
        data: response.news[0],
        model: 'news'
      });
      component.setState({
        ...update,
        'news[images]': images,
        'news[documents]': documents,
        '__files-news[images]': images,
        '__files-news[documents]': documents,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
    component.setState({});
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const news = (0, _getFormData.default)({
      state: state,
      pattern: 'news['
    });
    const url = props.type === 'update' ? '/news/update' : '/news/create';
    qwest.post(url, news).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchNews();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/contenu/liste-des-actualites');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('news[')).reduce(function (update, key) {
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/news/create"
    }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 9,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['news[title]'],
      name: "news[title]",
      type: "text",
      label: "Titre",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      label: "Date de l'actualit\xE9",
      name: "news[date]",
      onChange: component.handleChange,
      value: state['news[date]'],
      error: state.status_messages?.['news[date]']?.error
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 8,
      classes: props.classes,
      className: "form-side-switch-input"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-switch-form-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      onChange: component.handleChange,
      value: state['news[visibility]'] === true,
      name: "news[visibility]",
      "top-label": "Publi\xE9e",
      "left-label": "Non",
      label: "Oui",
      status: state.status_messages,
      "full-width": false
    })), /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      label: "Publier automatiquement le",
      name: "news[published_date]",
      onChange: component.handleChange,
      value: state['news[published_date]'],
      error: state.status_messages?.['news[published_date]']?.error,
      "read-only": (0, _utilities.isTrue)(state['news[visibility]'])
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state['news[description]'] || '',
      name: "news[description]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".jpg,.jpeg,.png,.gif",
      onChange: component.handleFileChange,
      name: "news[images]",
      data: state,
      status: state.status_messages,
      label: "Image"
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".pdf",
      onChange: component.handleFileChange,
      name: "news[documents]",
      data: state,
      status: state.status_messages,
      label: "Document"
    })))), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20\r u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cette actualité', loader)));
    return output;
  }
}
exports.default = NewsForm;
